export const {
  REACT_APP_SERVER,
  REACT_APP_SPOTIFY_AUTH_API,
  REACT_APP_PAYPAL_CLIENT_KEYS,
  REACT_APP_PAYPAL_ENVIRONMENT,
  REACT_APP_ADMIN_EMAIL,
  REACT_APP_SOCKET_URL,
  REACT_APP_SENTRY_DSN,
  REACT_APP_GTM_CONTAINER,
  REACT_APP_INTERCOM_APP_ID,
  REACT_APP_PAYPAL_CLIENT_KEY_SANDBOX,
  REACT_APP_PAYPAL_CLIENT_KEY_PRODUCTION,
  REACT_APP_TIKTOK_SERVER,
  REACT_APP_TIKTOK_AUTH_API,
} = process.env

export const APP = {
  SERVER: REACT_APP_SERVER,
  SENTRY_DSN: REACT_APP_SENTRY_DSN,
  GTM_CONTAINER: REACT_APP_GTM_CONTAINER,
  INTERCOM_APP_ID: REACT_APP_INTERCOM_APP_ID,
  SPOTIFY_AUTH_API: REACT_APP_SPOTIFY_AUTH_API,
  paypal_environment: REACT_APP_PAYPAL_ENVIRONMENT, // sandbox or production
  admin_email: REACT_APP_ADMIN_EMAIL.split(','),
  SOCKET_URL: REACT_APP_SOCKET_URL,
  PAYPAL_CLIENT_KEY_SANDBOX: REACT_APP_PAYPAL_CLIENT_KEY_SANDBOX,
  PAYPAL_CLIENT_KEY_PRODUCTION: REACT_APP_PAYPAL_CLIENT_KEY_PRODUCTION,
  TIKTOK_SERVER: REACT_APP_TIKTOK_SERVER,
  TIKTOK_AUTH_API: REACT_APP_TIKTOK_AUTH_API,
}
